module.exports = __webpack_public_path__ + "img/boardgames.a9137837.jpg";